"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _splitpanes = require("splitpanes");
require("splitpanes/dist/splitpanes.css");
var _index = _interopRequireDefault(require("@/views/trial/videoTrial/components/Detect/index.vue"));
var _Stream = _interopRequireDefault(require("@/views/trial/videoTrial/components/Stream.vue"));
var _rtc = _interopRequireDefault(require("./components/mixins/rtc.js"));
var _usersigMin = _interopRequireDefault(require("./components/utils/usersig.min.js"));
var _iconify = _interopRequireDefault(require("@iconify/iconify"));
var _trial = require("@/api/trial.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_rtc.default],
  components: {
    Splitpanes: _splitpanes.Splitpanes,
    Pane: _splitpanes.Pane,
    Detect: _index.default,
    Stream: _Stream.default
  },
  data: function data() {
    return {
      logList: [],
      type: "",
      sdkAppId: 1400714181,
      secretKey: "9bf14567644b1301d197de9cf4d5fc0d7117d26c447e30022e911d52a960629e",
      //本地userid
      userId: "",
      checkUserId: "",
      checkUser: {},
      roomId: 0,
      cameraId: "",
      microphoneId: "",
      inviteUserSig: "",
      userSig: "",
      dialogSignature: false,
      dialogDetectVisible: false,
      tabActiveName: "first",
      roleList: {
        main: 4,
        admin: 5,
        auxiliary: 6
      },
      height: "200px",
      caseId: 0,
      timeInterval: null,
      caseNo: "",
      id: "",
      udpateMarkRecordForm: {},
      partyType: {
        1: "申请人",
        2: "被申请人",
        4: "申请人代理",
        5: "被申请人代理",
        6: "仲裁员",
        7: "书记员"
        // 7: "秘书"
      },

      idtype: {
        0: "其他类型",
        1: "统一信用代码",
        2: "组织证书",
        3: "身份证",
        4: "军官证",
        5: "律师证"
      },
      record: {},
      partyList: [],
      // currentUserId: "",
      streamList: {
        main: null,
        s1: null,
        s2: null,
        s3: null,
        s4: null,
        s5: null,
        s6: null,
        s7: null,
        s8: null
      },
      applicant: [],
      respondent: [],
      recordCaseSituationData: {
        appProofFileList: [],
        resProofFileList: []
      },
      audioNoticeData: [],
      dialogRecordCaseSituationVisible: false,
      // dialogMarkVisible: false,
      markForm: {
        partyType: "",
        content: ""
      },
      markRecordData: [],
      hasRecordHandsRecord: false,
      recordHeight: 100,
      otherHeight: 100,
      commonly: [],
      commonlyValue: "",
      hasMarkBookRecord: false,
      hasGetMarkBookRecord: false,
      dialogEditMarkRecord: false
    };
  },
  computed: {
    title: function title() {
      return this.record.caseId + "- " + this.record.caseNo + "[" + this.record.resName + "]" + "-" + this.record.date;
    }
  },
  methods: {
    getUserID: function getUserID() {
      // let userId = localStorage.getItem("user_id");
      // if (!userId) {
      //   userId = `user_${parseInt(Math.random() * 100000000, 10)}`;
      //   localStorage.setItem("user_id", userId);
      // }
      // alert(this.$store.state.user.role);
      return "user_" + this.checkUserId;
      // return this.$store.state.user.name;

      // return this.$store.state.user.userID;
      // return this.$store.state.user;
    },
    removeUser: function removeUser(user) {
      (0, _trial.removeUser)({
        roomId: this.roomId,
        userIds: ["user_" + user]
      }).then(function (res) {
        if (res.code === 1) {
          // this.arbitratorList = res.data;
        }
      });
    },
    postTrtcControl: function () {
      var _postTrtcControl = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(userId, mikeStatus, videoStatus) {
        var _yield$trtcControl, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _trial.trtcControl)({
                userId: userId,
                mikeStatus: mikeStatus,
                videoStatus: videoStatus
              });
            case 2:
              _yield$trtcControl = _context.sent;
              data = _yield$trtcControl.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function postTrtcControl(_x, _x2, _x3) {
        return _postTrtcControl.apply(this, arguments);
      }
      return postTrtcControl;
    }(),
    start: function () {
      var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var userSigGenerator;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.userId = this.getUserID();
              userSigGenerator = new _usersigMin.default(this.sdkAppId, this.secretKey, 604800);
              this.userSig = userSigGenerator.genTestUserSig(this.userId);
              _context2.next = 5;
              return this.initClient();
            case 5:
              _context2.next = 7;
              return this.join();
            case 7:
              if (!(this.checkUser.partyType != 7)) {
                _context2.next = 14;
                break;
              }
              _context2.next = 10;
              return this.initLocalStream();
            case 10:
              _context2.next = 12;
              return this.playLocalStream();
            case 12:
              _context2.next = 14;
              return this.publish();
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }(),
    addSuccessLog: function addSuccessLog(log) {
      // if (!this.isHostMode) {
      //   return;
      // }
      this.logList.push({
        type: "success",
        log: log
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    // 显示失败的 Log
    addFailedLog: function addFailedLog(log) {
      // if (!this.isHostMode) {
      //   return;
      // }
      this.logList.push({
        type: "failed",
        log: log
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    handleDetect: function handleDetect() {
      this.dialogDetectVisible = true;
    },
    handleDetectStart: function () {
      var _handleDetectStart = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.start();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleDetectStart() {
        return _handleDetectStart.apply(this, arguments);
      }
      return handleDetectStart;
    }(),
    handleDetectSuccess: function handleDetectSuccess() {
      this.dialogDetectVisible = false; // this.handleDetectStart();
    },
    reportSuccessEvent: function reportSuccessEvent(name) {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-success`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId
      // });
    },
    reportFailedEvent: function reportFailedEvent(name, error) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "rtc";
    } // this.$aegis.reportEvent({
    //   name,
    //   ext1: `${name}-failed#${this.roomId}*${
    //     type === "share" ? this.shareUserId : this.userId
    //   }*${error.message}`,
    //   ext2: "webrtcQuickDemoVue2",
    //   ext3: this.sdkAppId
    // });
    ,
    handleLeave: function () {
      var _handleLeave = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.leave();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleLeave() {
        return _handleLeave.apply(this, arguments);
      }
      return handleLeave;
    }(),
    handleJoin: function () {
      var _handleJoin = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.start();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleJoin() {
        return _handleJoin.apply(this, arguments);
      }
      return handleJoin;
    }(),
    handleClick: function handleClick(type, action, obj) {
      var userId = obj.id;
      if (type == "rtc") {} else if (type == "video") {
        if (action) {
          // this.unmuteVideo();
          //视频打开
          this.postTrtcControl(userId, 0, 1);
        } else {
          // this.muteVideo();
          //视频关闭
          this.postTrtcControl(userId, 0, 2);
        }
      } else if (type == "audio") {
        if (action) {
          this.postTrtcControl(userId, 1, 0);
          // this.unmuteAudio();
        } else {
          this.postTrtcControl(userId, 2, 0);
          // this.muteAudio();
        }
      } else if (type == "remove") {
        this.removeUser(obj.id);
      }
      console.log(type, action, obj);
    },
    handleRecordFinish: function () {
      var _handleRecordFinish = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        var _this = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$confirm("是否结束视频庭审?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return (0, _trial.recordFinish)({
                        trialId: _this.checkUser.trialId
                      });
                    case 2:
                      _this.notify("消息", "已经结束庭审");
                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleRecordFinish() {
        return _handleRecordFinish.apply(this, arguments);
      }
      return handleRecordFinish;
    }(),
    handleMarkCommit: function () {
      var _handleMarkCommit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              this.$confirm("是否提交笔录?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
                return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _context8.next = 2;
                      return (0, _trial.markCommit)({
                        trialId: _this2.checkUser.trialId
                      });
                    case 2:
                      _this2.notify("消息", "提交成功");
                    case 3:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }))).catch(function () {});
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function handleMarkCommit() {
        return _handleMarkCommit.apply(this, arguments);
      }
      return handleMarkCommit;
    }(),
    handleRecordCaseSituation: function handleRecordCaseSituation() {
      this.dialogRecordCaseSituationVisible = true;
    },
    handleRecordCaseSituationOpen: function handleRecordCaseSituationOpen(row) {
      window.open(row.aliyunOssHref);
    },
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10() {
        var _this3 = this;
        var streamList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.respondent = [];
              this.applicant = [];
              streamList = {};
              this.partyList.map(function (item) {
                var key = "user_" + item.id;
                var title = _this3.partyType[item.partyType] + ":" + item.name;
                if (item.partyType == 1) {
                  _this3.applicant.push(item);
                  //申请人 s1 s2
                  if (streamList.s1 == null) {
                    streamList.s1 = {
                      key: key,
                      id: item.id,
                      title: title,
                      type: _this3.checkUser.partyType
                    };
                  } else {
                    streamList.s2 = {
                      key: key,
                      id: item.id,
                      title: title,
                      type: _this3.checkUser.partyType
                    };
                  }
                } else if (item.partyType == 2) {
                  //被申请人 s3 s4
                  _this3.respondent.push(item);
                  if (streamList.s3 == null) {
                    streamList.s3 = {
                      key: key,
                      id: item.id,
                      title: title,
                      type: _this3.checkUser.partyType
                    };
                  } else {
                    streamList.s4 = {
                      key: key,
                      id: item.id,
                      title: title,
                      type: _this3.checkUser.partyType
                    };
                  }
                } else if (item.partyType == 4) {
                  //申请人代理
                  streamList.s5 = {
                    key: key,
                    id: item.id,
                    title: title,
                    type: _this3.checkUser.partyType
                  };
                } else if (item.partyType == 5) {
                  //
                  streamList.s6 = {
                    key: key,
                    id: item.id,
                    title: title,
                    type: _this3.checkUser.partyType
                  };
                } else if (item.partyType == 6) {
                  //仲裁员 main
                  streamList.main = {
                    key: key,
                    id: item.id,
                    title: title,
                    type: _this3.checkUser.partyType
                  };
                } else if (item.partyType == 7) {
                  //书记员 s8
                  streamList.s8 = {
                    key: key,
                    id: item.id,
                    title: title,
                    type: _this3.checkUser.partyType
                  };
                }
                //可能没有
                // else if (item.partyType == 7) {
                //   //秘书
                //   streamList.s7 = {
                //     key: key,
                // id: item.id,
                //     title: title,
                // type: this.checkUser.partyType
                //   };
                // }
              });

              this.streamList = streamList;
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    resize: function resize() {
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.height = h - 124 + "px";
      this.otherHeight = h - 200 + "px";
      if (this.checkUser.partyType == 7) {
        this.recordHeight = h - 540 + "px";
      } else {
        this.recordHeight = this.otherHeight;
      }
    },
    getRecord: function () {
      var _getRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11() {
        var _yield$recordSelect, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return (0, _trial.recordSelect)(this.id, {
                caseId: this.caseId,
                caseNo: this.caseNo
              });
            case 2:
              _yield$recordSelect = _context11.sent;
              data = _yield$recordSelect.data;
              this.record = data;
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getRecord() {
        return _getRecord.apply(this, arguments);
      }
      return getRecord;
    }(),
    //获取所有参庭人员
    getPartyList: function () {
      var _getPartyList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee12() {
        var _this4 = this;
        var _yield$partyPage, rows;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return (0, _trial.partyPage)({
                caseId: this.caseId,
                page: 1,
                limit: 100
              });
            case 2:
              _yield$partyPage = _context12.sent;
              rows = _yield$partyPage.rows;
              this.respondent = [];
              this.applicant = [];
              rows.map(function (item) {
                if (item.partyType == 1) {
                  _this4.applicant.push(item);
                }
                if (item.partyType == 2) {
                  _this4.respondent.push(item);
                }
              });
              this.partyList = rows;
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getPartyList() {
        return _getPartyList.apply(this, arguments);
      }
      return getPartyList;
    }(),
    //获取案情&材料
    getRecordCaseSituation: function () {
      var _getRecordCaseSituation = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee13() {
        var _yield$recordCaseSitu, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return (0, _trial.recordCaseSituation)(this.caseId);
            case 2:
              _yield$recordCaseSitu = _context13.sent;
              data = _yield$recordCaseSitu.data;
              this.recordCaseSituationData = data;
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getRecordCaseSituation() {
        return _getRecordCaseSituation.apply(this, arguments);
      }
      return getRecordCaseSituation;
    }(),
    getCheckUser: function () {
      var _getCheckUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee14() {
        var _yield$recordCheckUse, code, data, msg;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return (0, _trial.recordCheckUser)({
                recordId: this.id
              });
            case 2:
              _yield$recordCheckUse = _context14.sent;
              code = _yield$recordCheckUse.code;
              data = _yield$recordCheckUse.data;
              msg = _yield$recordCheckUse.msg;
              if (!(code != 1)) {
                _context14.next = 10;
                break;
              }
              this.$msgbox({
                title: "消息",
                message: msg,
                type: "error",
                showCancelButton: false,
                // showClose: false,
                showConfirmButton: false,
                closeOnClickModal: false
              }).then(function (action) {});
              _context14.next = 15;
              break;
            case 10:
              this.checkUser = data;
              this.checkUserId = data.id;
              this.roomId = data.roomNo;
              _context14.next = 15;
              return this.getInitData();
            case 15:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getCheckUser() {
        return _getCheckUser.apply(this, arguments);
      }
      return getCheckUser;
    }(),
    getAudioNotice: function () {
      var _getAudioNotice = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee15() {
        var _yield$audioNoticePag, rows;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return (0, _trial.audioNoticePage)({
                page: 1,
                limit: 100
              });
            case 2:
              _yield$audioNoticePag = _context15.sent;
              rows = _yield$audioNoticePag.rows;
              this.audioNoticeData = rows;
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getAudioNotice() {
        return _getAudioNotice.apply(this, arguments);
      }
      return getAudioNotice;
    }(),
    getMarkRecord: function () {
      var _getMarkRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee16() {
        var _this5 = this;
        var _yield$markRecord, data, _iterator, _step, _loop;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee16$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              console.log("获取记录");
              // alert(this.checkUser.trialId);
              _context17.next = 3;
              return (0, _trial.markRecord)({
                trialId: this.checkUser.trialId
              });
            case 3:
              _yield$markRecord = _context17.sent;
              data = _yield$markRecord.data;
              // let t = JSON.parse(JSON.stringify(data));
              // console.log(Date.parse("1980-01-01 " + data[0].time));
              // let t = data.sort((a, b) => {
              //   console.log(
              //     Date.parse("1980-01-01 " + a.time) -
              //       Date.parse("1980-01-01 " + b.time)
              //   );
              //   return (
              //     Date.parse("1980-01-01 " + a.time) -
              //     Date.parse("1980-01-01 " + b.time)
              //   );
              // });
              this.markRecordData = [];
              if (!(data.length > 0)) {
                _context17.next = 23;
                break;
              }
              _iterator = (0, _createForOfIteratorHelper2.default)(data);
              _context17.prev = 8;
              _loop = /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _loop() {
                var i, name;
                return (0, _regeneratorRuntime2.default)().wrap(function _loop$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      i = _step.value;
                      name = "";
                      _this5.partyList.map(function (item) {
                        if (i.partyType == item.partyType) {
                          name = item.name;
                        }
                      });
                      i["n"] = name;
                      _this5.markRecordData.push(i);
                    case 5:
                    case "end":
                      return _context16.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 11:
              if ((_step = _iterator.n()).done) {
                _context17.next = 15;
                break;
              }
              return _context17.delegateYield(_loop(), "t0", 13);
            case 13:
              _context17.next = 11;
              break;
            case 15:
              _context17.next = 20;
              break;
            case 17:
              _context17.prev = 17;
              _context17.t1 = _context17["catch"](8);
              _iterator.e(_context17.t1);
            case 20:
              _context17.prev = 20;
              _iterator.f();
              return _context17.finish(20);
            case 23:
            case "end":
              return _context17.stop();
          }
        }, _callee16, this, [[8, 17, 20, 23]]);
      }));
      function getMarkRecord() {
        return _getMarkRecord.apply(this, arguments);
      }
      return getMarkRecord;
    }(),
    handleEditMarkRecord: function handleEditMarkRecord(item) {
      this.udpateMarkRecordForm = item;
      this.dialogEditMarkRecord = true;
    },
    updateMarkSend: function () {
      var _updateMarkSend = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee17() {
        var data, _yield$markSend, code;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee17$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              data = {
                content: this.udpateMarkRecordForm.content,
                partyType: this.udpateMarkRecordForm.partyType,
                trialId: this.udpateMarkRecordForm.trialId,
                time: this.udpateMarkRecordForm.time
              };
              _context18.next = 3;
              return (0, _trial.markSend)(data);
            case 3:
              _yield$markSend = _context18.sent;
              code = _yield$markSend.code;
              this.dialogEditMarkRecord = false;
              if (code == 1) {
                this.notify("通知", "庭审笔录修改成功", "success");
              }
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee17, this);
      }));
      function updateMarkSend() {
        return _updateMarkSend.apply(this, arguments);
      }
      return updateMarkSend;
    }(),
    postMarkSend: function () {
      var _postMarkSend = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee18() {
        var current, h, m, s, data, _yield$markSend2, code;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee18$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              current = new Date();
              h = current.getHours(), m = current.getMinutes(), s = current.getSeconds();
              if (h < 10) h = "0" + h;
              if (m < 10) m = "0" + m;
              if (s < 10) s = "0" + s;
              data = {
                content: this.markForm.content,
                partyType: this.markForm.partyType,
                trialId: this.checkUser.trialId,
                time: h + ":" + m + ":" + s
              };
              _context19.next = 8;
              return (0, _trial.markSend)(data);
            case 8:
              _yield$markSend2 = _context19.sent;
              code = _yield$markSend2.code;
              if (code == 1) {
                this.$notify.info({
                  title: "消息",
                  duration: 3000,
                  message: "添加记录成功"
                });
              }
              _context19.next = 13;
              return this.getMarkRecord();
            case 13:
              this.markForm.content = "";
              // this.audioNoticeData = rows;
            case 14:
            case "end":
              return _context19.stop();
          }
        }, _callee18, this);
      }));
      function postMarkSend() {
        return _postMarkSend.apply(this, arguments);
      }
      return postMarkSend;
    }(),
    handlePostHandsFix: function () {
      var _handlePostHandsFix = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee19() {
        var _yield$recordHandsFix, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee19$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return (0, _trial.recordHandsFix)({
                trialId: this.checkUser.trialId
              });
            case 2:
              _yield$recordHandsFix = _context20.sent;
              data = _yield$recordHandsFix.data;
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee19, this);
      }));
      function handlePostHandsFix() {
        return _handlePostHandsFix.apply(this, arguments);
      }
      return handlePostHandsFix;
    }(),
    //获取举手列表
    getRecordHandsRecord: function () {
      var _getRecordHandsRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee20() {
        var _this6 = this;
        var _yield$recordHandsRec, data, msg, _iterator2, _step2, item;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee20$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!(this.checkUser.partyType != 7)) {
                _context21.next = 2;
                break;
              }
              return _context21.abrupt("return");
            case 2:
              _context21.next = 4;
              return (0, _trial.recordHandsRecord)({
                trialId: this.checkUser.trialId
              });
            case 4:
              _yield$recordHandsRec = _context21.sent;
              data = _yield$recordHandsRec.data;
              if (!this.hasRecordHandsRecord) {
                if (data.length > 0) {
                  msg = "";
                  _iterator2 = (0, _createForOfIteratorHelper2.default)(data);
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      item = _step2.value;
                      msg = msg + "<div><strong>[" + this.partyType[item.partyType] + "]" + item.name + "</strong> 举手</div>";
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                  this.$notify({
                    title: "举手提示",
                    dangerouslyUseHTMLString: true,
                    message: msg,
                    type: "warning",
                    position: "bottom-right",
                    duration: 0,
                    onClose: function onClose() {
                      _this6.handlePostHandsFix();
                      _this6.hasRecordHandsRecord = false;
                    }
                  });
                  this.hasRecordHandsRecord = true;
                }
              }
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee20, this);
      }));
      function getRecordHandsRecord() {
        return _getRecordHandsRecord.apply(this, arguments);
      }
      return getRecordHandsRecord;
    }(),
    getMarkCommonlyList: function () {
      var _getMarkCommonlyList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee21() {
        var _yield$markCommonlyLi, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee21$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return (0, _trial.markCommonlyList)({});
            case 2:
              _yield$markCommonlyLi = _context22.sent;
              data = _yield$markCommonlyLi.data;
              this.commonly = data;
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee21, this);
      }));
      function getMarkCommonlyList() {
        return _getMarkCommonlyList.apply(this, arguments);
      }
      return getMarkCommonlyList;
    }(),
    handlecommonlyValueChange: function handlecommonlyValueChange(value) {
      this.markForm.content = value;
    },
    notify: function notify(title, msg, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: msg,
        type: type,
        position: "bottom-right",
        // duration: 0,
        onClose: function onClose() {
          // this.handlePostHandsFix();
          // this.hasRecordHandsRecord = false;
        }
      });
    },
    getTrtcGetControl: function () {
      var _getTrtcGetControl = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee22() {
        var _yield$trtcGetControl, code, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return (0, _trial.trtcGetControl)({
                userId: this.checkUser.id
              });
            case 2:
              _yield$trtcGetControl = _context23.sent;
              code = _yield$trtcGetControl.code;
              data = _yield$trtcGetControl.data;
              if (data.mikeStatus == 1) {
                this.notify("通知", "您的声音已经被管理员打开", "success");
                this.unmuteAudio();
              }
              if (data.mikeStatus == 2) {
                this.notify("通知", "您的声音已经被管理员关闭", "error");
                this.muteAudio();
              }
              if (data.videoStatus == 1) {
                this.notify("通知", "您的视频已经被管理员打开", "success");
                this.unmuteVideo();
              }
              if (data.videoStatus == 2) {
                this.notify("通知", "您的视频已经被管理员关闭", "error");
                this.muteVideo();
              }
              console.log("控制-------------", this.checkUser.id, data);
            case 10:
            case "end":
              return _context23.stop();
          }
        }, _callee22, this);
      }));
      function getTrtcGetControl() {
        return _getTrtcGetControl.apply(this, arguments);
      }
      return getTrtcGetControl;
    }(),
    getMarkBookRecord: function () {
      var _getMarkBookRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee23() {
        var _yield$markBookRecord, code, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee23$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return (0, _trial.markBookRecord)({
                partyId: this.checkUser.id
              });
            case 2:
              _yield$markBookRecord = _context24.sent;
              code = _yield$markBookRecord.code;
              data = _yield$markBookRecord.data;
              if (!data) {
                _context24.next = 9;
                break;
              }
              this.hasGetMarkBookRecord = true;
              _context24.next = 9;
              return this.getPartyList();
            case 9:
              if (data && !this.hasMarkBookRecord) {
                this.$alert("<strong>点击<a style='color:#409EFF' target='_blank' href='" + data.path + "'>查看</a>，案件庭审笔录</strong>", "网络案件庭审笔录", {
                  dangerouslyUseHTMLString: true
                }).then(function () {
                  // if (this.checkUser.partyType != 7) {
                  //   this.dialogSignature = true;
                  // }
                  // this.closeView();
                }).catch(function (action) {
                  // 签名
                  // if (this.checkUser.partyType != 7) {
                  //   this.dialogSignature = true;
                  // }
                  // this.closeView();
                });
                this.hasMarkBookRecord = true;
              }
            case 10:
            case "end":
              return _context24.stop();
          }
        }, _callee23, this);
      }));
      function getMarkBookRecord() {
        return _getMarkBookRecord.apply(this, arguments);
      }
      return getMarkBookRecord;
    }(),
    getTime: function () {
      var _getTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee24() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee24$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (this.checkUser.partyType != 7) {
                this.getTrtcGetControl();
              }
              _context25.next = 3;
              return this.getMarkBookRecord();
            case 3:
              _context25.next = 5;
              return this.getMarkRecord();
            case 5:
              _context25.next = 7;
              return this.getRecordHandsRecord();
            case 7:
            case "end":
              return _context25.stop();
          }
        }, _callee24, this);
      }));
      function getTime() {
        return _getTime.apply(this, arguments);
      }
      return getTime;
    }(),
    // async showMarkSend() {
    //   this.dialogMarkVisible = true;
    // },
    getInitData: function () {
      var _getInitData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee25() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee25$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return this.getRecord();
            case 2:
              _context26.next = 4;
              return this.getPartyList();
            case 4:
              _context26.next = 6;
              return this.getRecordCaseSituation();
            case 6:
              _context26.next = 8;
              return this.getAudioNotice();
            case 8:
              _context26.next = 10;
              return this.getMarkCommonlyList();
            case 10:
              if (!(this.checkUser.partyType != 7)) {
                _context26.next = 14;
                break;
              }
              this.dialogDetectVisible = true;
              _context26.next = 16;
              break;
            case 14:
              _context26.next = 16;
              return this.start();
            case 16:
              this.init();
              this.getTime();
              this.timeInterval = window.setInterval(this.getTime, 5000);
            case 19:
            case "end":
              return _context26.stop();
          }
        }, _callee25, this);
      }));
      function getInitData() {
        return _getInitData.apply(this, arguments);
      }
      return getInitData;
    }(),
    closeView: function closeView() {
      this.$store.dispatch("tagsView/delView", {
        name: "videoTrial",
        path: "/trial/trial/videoTrial"
      });
      this.$router.go(-1);
    },
    undo: function undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save: function () {
      var _save = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee26() {
        var _this$$refs$signature, isEmpty, data, _yield$trialPartySign, code;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee26$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _this$$refs$signature = this.$refs.signaturePad.saveSignature(), isEmpty = _this$$refs$signature.isEmpty, data = _this$$refs$signature.data;
              console.log(isEmpty);
              console.log(data);
              _context27.next = 5;
              return (0, _trial.trialPartySign)({
                partyId: this.checkUser.id,
                base64: data
              });
            case 5:
              _yield$trialPartySign = _context27.sent;
              code = _yield$trialPartySign.code;
              if (code == 1) {
                this.notify("通知", "你的签名已经保存。", "success");
                this.dialogSignature = false;
                // this.closeView();
              }
            case 8:
            case "end":
              return _context27.stop();
          }
        }, _callee26, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }(),
    clear: function clear() {
      this.$refs.signaturePad.clearSignature();
    }
  },
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee27() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee27$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            if (this.timeInterval) window.clearInterval(this.timeInterval);
            _context28.next = 3;
            return this.leave();
          case 3:
          case "end":
            return _context28.stop();
        }
      }, _callee27, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee28() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee28$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            this.resize();
            console.log(this.$route.query.caseId);
            this.caseId = this.$route.query.caseId;
            this.caseNo = this.$route.query.caseNo;
            this.id = this.$route.query.id;
            _context29.next = 7;
            return this.getCheckUser();
          case 7:
            this.resize();
            window.onresize = this.resize;
          case 9:
          case "end":
            return _context29.stop();
        }
      }, _callee28, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }()
};
exports.default = _default;